/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import ChipInput from 'material-ui-chip-input';
import { FormControl, Typography, FormHelperText } from '@material-ui/core';
const styles = theme => ({

})

class FlexTextList extends Component {
    state = {
        value : null,
        error : false,
        helper_text : "",
        chips: [],
        name: null

    }

    componentWillMount () {
        console.log("Type: ", this.props.instance.component)
        console.log("ID: ", this.props.instance.id)
        this.setState({...this.state, chips : this.props.instance.value.list }, () => { this.setErrorAndHelperText(); })
    }

    getParam = (param_name, value_type) => {
        let parameter = null
        if (this.props.instance.component_params !== null) {
            this.props.instance.component_params.map(param => {
                if (param.name === param_name) {
                    parameter = param.value[value_type]
                }
            })
        }

        return parameter
    }

    setErrorAndHelperText = () => {
        let config_error = this.getParam("error", "boolean")
        let helper_text = this.getParam("helper_text", "text")
        let error_message = this.getParam("error_message", "text") !== null ? this.getParam("error_message", "text") : this.getParam("helper_text", "text")

        if (config_error !== null) {
            this.setState({...this.state, 
                error : config_error, 
                helper_text : config_error === true ? error_message : helper_text
            })
        } else {
            this.setState({
                ...this.state,
                helper_text : helper_text
            })
        }
    }

    getErrorAndHelperText = () => {
        let state_error = this.state.error

        if (state_error === true) {
            this.setState({...this.state, error : true}, () => this.getHelperText())
        }
    }

    getHelperText = () => {
        let helper_text
        if (this.state.error === false) {
            helper_text = this.getParam("helper_text", "text")
        } else {
            helper_text = "Invalid entry"
        }

        this.setState({...this.state, helper_text : helper_text})
    }

    handleChange = (event, newValue) => {
        this.setState({ ...this.state, value: newValue })
    }

    getValueType = (component) => {
        console.log("valye type")
        console.log(component)
        switch (component) {
            case "text" :
                return "text"
            
            case "number" :
                return "number"

            case "email" :
                return "text"

            case "password" :
                return "text"

            case "url" :
                return "text"

            case "text_list":
                return "list"

            default:
                return "text"
        }
    }

    validateAndPush = () => {
        console.log('Validating! ', this.props.instance.id)
        if (this.validate(this.props.instance.component)) {
            this.setState({...this.state, error : false}, () => {
                this.getHelperText()
                this.props.update_value(this.props.instance.id, "list", this.state.chips)
            })
        } else {
            this.setState({...this.state, error : true}, () => {
                this.getHelperText()
            })
        }
    }

    validate = (validation_type) => {
        switch (validation_type) {
            case "email":
                return this.validateEmail()
            
            // case "url" :
            //     return this.validateUrl()
            
            default:
                return true
        }
    }

    handleAddChip(chips) {
        console.log("chip")
        console.log(chips)

       // chips.push(chips)
        this.setState({
          //chips: [...this.state.chips, chip]
          chips: chips
        }, () => {
            this.validateAndPush()
        });
      }
    
    handleDeleteChip(deletedChip) {
        this.setState({
            chips: this.state.chips.filter(c => c !== deletedChip)
        });
    }
    
    render() {
        const { classes } = this.props
        return (
            <Fragment>
                <FormControl
                    style = {{width : '100%'}}
                    variant = 'standard' 
                    margin = 'dense'
                    error = {this.state.error}
                    disabled = {this.props.disabled}
                >
                    {/* <Typography>{ this.props.instance.name } </Typography> */}
                    <ChipInput 
                        defaultValue={ this.state.chips }
                        onChange={(chips) => this.handleAddChip(chips)}
                        onDelete={(chip, index) => this.handleDeleteChip(chip)}
                        fullWidth
                        label = {this.props.instance.name}
                        size = 'small'
                    />  
                    
                    <FormHelperText>{this.state.helper_text}</FormHelperText>
                </FormControl>
                
            </Fragment>
        );
    }
}

export default withStyles(styles)(FlexTextList)